export const getPropertyValue =
  <T extends Record<P, unknown>, P extends keyof T>(property: P) =>
  (record: T): T[P] =>
    record[property]
